module.exports = __webpack_public_path__ + "partylineManage/img/callupBg.928bf270.png";